import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { IS_PRESUMABLY_EXISTING_CUSTOMER, MUI_MOBILE_BREAKPOINT } from '../../../../../utils/constants';
import { calculateSubtotalOfExclusions, isLoopReturnsActive, useCartData } from '../../../../../utils/cart';
import { openSignInModal } from '../../../../../templates/_shared/ui-components/SignInModal/utils';
import { fireHeapOpenSignInsignUpModalEvent } from '../../../../../utils/heap-events';
import { getLoyaltyBlockedStatus } from 'src/scripts/templates/_shared/loyaltyBlockedStatus';
import { toJS } from 'mobx';
import { loyaltyState } from './loyaltyState';
import './rewards-styles.scss';
import { observer } from 'mobx-react-lite';
import { CurrencyState, getUsersPreferredCurrency } from '../../../../../utils/currency';
import { ShippingCountryState } from '../../../../../utils/shipping';
import { RewardsCarousel } from './RewardsCarousel';
import { Customer } from '../../../../../utils/environment';

let Rewards = ({
  shouldHideLLwidget = false,
  redeemButtonText,
  customSubtitleBeforePoints = 'You’re eligible for gifts and rewards.',
}: {
  shouldHideLLwidget: boolean;
  redeemButtonText?: string;
  customSubtitleBeforePoints?: string;
}) => {
  const cartData = useCartData();
  const subtotalOfExludedProductsFromCalculation = calculateSubtotalOfExclusions(cartData);
  const cartSubtotal = Math.round((cartData.subtotal - subtotalOfExludedProductsFromCalculation) / 100);

  const currentRates = toJS(CurrencyState.exchangeRates);
  const currentCurrency = toJS(ShippingCountryState.country?.currencyCode) || getUsersPreferredCurrency();
  const rate = currentCurrency ? currentRates?.[currentCurrency?.toUpperCase()] : null;
  const approximateLoyaltyPointsToEarn = rate ? Math.floor(cartSubtotal / rate) : null;

  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true });

  const [isUserBlocked, setIsUserBlocked] = useState(false);
  const isCustomer = !!Customer.id;

  useEffect(() => {
    const getUserStatus = async () => {
      setIsUserBlocked(await getLoyaltyBlockedStatus());
    };
    getUserStatus();
  }, []);

  const icons: Record<string, string> = {
    guest: 'https://cdn.shopify.com/s/files/1/2185/2813/files/aloaccess_bl.svg?v=1694461849',
    tier1: 'https://cdn.shopify.com/s/files/1/2185/2813/files/vip_aloaccess_blk.svg?v=1689943806',
    tier2: 'https://cdn.shopify.com/s/files/1/2185/2813/files/alist_aloaccess_blk.svg?v=1689943884',
    tier3: 'https://cdn.shopify.com/s/files/1/2185/2813/files/allaccess_aloaccess_blk.svg?v=1689943885',
  };

  const currentIcon = isCustomer ? icons[loyaltyState.tier] : icons.guest;

  const subTitle = (
    <>
      {isCustomer ? (
        shouldHideLLwidget ? (
          <>
            Earn{' '}
            {approximateLoyaltyPointsToEarn ? (
              <span className="points body bold">{approximateLoyaltyPointsToEarn} points</span>
            ) : (
              'points'
            )}{' '}
            with this purchase!{' '}
          </>
        ) : (
          <>
            {customSubtitleBeforePoints} You have{' '}
            <span className="points body bold">
              {loyaltyState.pointsBalance} {`${loyaltyState.pointsBalance === 1 ? 'point' : 'points'}`}
            </span>{' '}
            available. {isMobile && <br />}
          </>
        )
      ) : (
        <>
          Earn{' '}
          {approximateLoyaltyPointsToEarn ? (
            <span className="points body bold">{approximateLoyaltyPointsToEarn} points</span>
          ) : (
            'points'
          )}{' '}
          & exclusive rewards.{' '}
        </>
      )}
      {/* [REVISIT] attach open sign-in modal handler */}
      {!isCustomer && (
        <u
          style={{ cursor: 'pointer' }}
          onClick={() => {
            fireHeapOpenSignInsignUpModalEvent({
              ctaLocation: 'Loyalty Rewards Carousel Block',
              ctaName: 'Start Now',
            });
            openSignInModal({
              tab: IS_PRESUMABLY_EXISTING_CUSTOMER ? 'sign-in' : 'create-account',
            });
          }}
        >
          Start Now!
        </u>
      )}
    </>
  );

  // Do not show 0 balance while we are fetching the data and there's no default data from state.
  const shouldHidePointBalance = isCustomer && !loyaltyState.pointsBalance;

  if (isUserBlocked || isLoopReturnsActive()) return null;

  return (
    <div className={`rewards ${isCustomer ? 'customer' : ''}`}>
      <div className="hero">
        <img className="access-icon img-fluid" src={currentIcon} alt="Alo Access tier logo" />
        <div className="copy-column">
          {!shouldHidePointBalance ? (
            <p className="body">{subTitle}</p>
          ) : (
            // Render empty string to avoid layout shift
            <span style={{ height: '22.39px' }}></span>
          )}
        </div>
      </div>
      <>{!shouldHideLLwidget && <RewardsCarousel redeemButtonText={redeemButtonText} />}</>
    </div>
  );
};

Rewards = observer(Rewards);
export { Rewards };
